import { motion } from "framer-motion"
import { Element } from "react-scroll"
import { WhatsappLink } from ".."

const logoUrl = "images/Dineai.ico"

const Cta = () => {
  return (
    <Element id="contact" name="contact" className="relative py-12 overflow-hidden">

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between px-12 lg:px-0 text-center md:text-left">
        {/* Left Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex-2"
        >
          <h2 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6">
            <span className="text-orange-500">Ready to Turn Views Into Revenue?</span>
          </h2>

          <p className="text-lg text-gray-600 max-w-lg mx-auto md:ms-2 mb-10 text-justify">
            Boost engagement, increase order values,
            and serve customers better with real-time analytics and AI assistance. Get started today.
          </p>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
            onClick={() => window.open(WhatsappLink, "_blank")}
            className="px-10 py-4 rounded-full font-semibold text-lg bg-orange-500 hover:bg-orange-600 text-white shadow-lg transition"
          >
            Get Started
          </motion.button>
        </motion.div>

        {/* Right Section */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex-1 hidden md:flex justify-center md:justify-end mt-10 md:mt-0"
        >
          <img
            src={logoUrl}
            alt="DineAI Logo"
            className="w-48 md:w-64 lg:w-72 drop-shadow-2xl"
          />
        </motion.div>
      </div>
    </Element>
  )
}

export default Cta
